import type { CompetitorRecord } from "@/lib/compare/types";

const PRICING = "https://sendshort.ai/pricing";
const CHECKED = "2026-10-08";

export const SENDSHORT: CompetitorRecord = {
  slug: "sendshort",
  name: "SendShort",
  aliases: ["Sendshort", "Send Short", "sendshort.ai"],
  url: "https://sendshort.ai",
  pricingUrl: PRICING,
  category: "clipper",
  positioning:
    "Long video to shorts plus faceless videos, AI avatars and a TikTok and YouTube scheduler, sold on a per-short quota.",
  plans: [
    {
      name: "Starter",
      monthly: 19,
      annualPerMonth: 15,
      metered: "20 shorts per month, 90-second maximum per short",
      includes: [
        "1080p 30fps export, no watermark",
        "3 caption themes",
        "Scheduler for TikTok and YouTube, unlimited social accounts",
        "Full editor",
        "Long-video-to-shorts, API, custom themes and AI hook title are locked",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "Annual price shown as $15 per month (20% off). Long-video-to-shorts is locked on this plan.",
    },
    {
      name: "Professional",
      monthly: 29,
      annualPerMonth: 23,
      metered: "50 shorts per month, 3-minute maximum per short",
      includes: [
        "2K 30fps export",
        "Long-video-to-shorts unlocked",
        "Auto B-roll, AI voice-over, silence cutting, auto-translate",
        "AI Agent plus API",
        "2 automated series, 10 faceless videos a week",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "Annual price shown as $23 per month (23% off).",
    },
    {
      name: "Business",
      monthly: 59,
      annualPerMonth: 47,
      metered: "Unlimited shorts, described as 100+ a month subject to fair use, 10-minute maximum per short",
      includes: [
        "4K 60fps export",
        "Unlimited faceless videos and slideshows",
        "Aspect-ratio conversion 9:16, 1:1, 16:9",
        "SRT and green screen export",
        "10 automated series",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "Annual price shown as $47 per month (30% off).",
    },
  ],
  entryPlanName: "Starter",
  entryPlanIncludes:
    "20 shorts a month at up to 90 seconds each, 1080p, scheduler and editor; long-video-to-shorts is locked until Professional at $29",
  freeTier:
    "The pricing page header offers 3 free videos with no credit card; the FAQ on the same page answers the free-trial question with Not at the moment",
  trial: "Not at the moment, per the pricing page FAQ, although the header promises 3 free videos",
  meteringUnit: "1 short per finished clip you create or import; monthly limits do not roll over",
  exportResolution: "1080p 30fps on Starter, 2K 30fps on Professional, 4K 60fps on Business",
  features: {
    longToShort: { v: "partial", note: "Professional and up; locked on Starter" },
    momentRanking: { v: "partial", note: "Scores moments for retention, no number shown" },
    reframing: { v: "yes", note: "Tracks and centers the speaker" },
    maxSource: { v: "n/a", note: "Upload cap not published; outputs 90 s to 10 min" },
    layouts: { v: "n/a", note: "Not enumerated on the pricing page" },
    redditStory: { v: "yes", note: "Faceless videos, 3 to unlimited a week by plan" },
    fakeText: { v: "no" },
    aiImages: { v: "partial", note: "Slideshows and photo-to-video only" },
    voiceover: { v: "partial", note: "Professional and up" },
    voiceCloning: { v: "n/a", note: "Not listed" },
    avatars: { v: "yes" },
    timelineEditor: { v: "yes", note: "Full editor on all tiers" },
    captionStyles: { v: "text", note: "35+" },
    captionLanguages: { v: "text", note: "100+ captions, 50+ auto-translate" },
    bRoll: { v: "partial", note: "Auto B-roll on Professional and up" },
    fourK: { v: "partial", note: "Business only, 4K 60fps" },
    scheduling: { v: "yes", note: "TikTok and YouTube on every tier" },
    analytics: { v: "no", note: "Not listed" },
    socialTracker: { v: "no" },
    api: { v: "partial", note: "Pricing page says Professional, features page says Business" },
    webhooks: { v: "n/a", note: "Not published" },
    web: { v: "yes" },
    desktop: { v: "no", note: "Not advertised" },
    mobile: { v: "no", note: "Not advertised" },
    teamSeats: { v: "n/a", note: "Business says built for teams, no seat count" },
    freeTier: { v: "partial", note: "Header says 3 free videos, FAQ says no trial" },
    trial: { v: "partial", note: "FAQ: Not at the moment" },
    metering: { v: "text", note: "1 short per finished or imported clip" },
    rollover: { v: "no", note: "Monthly limits do not roll over" },
    refunds: { v: "text", note: "24-hour refund window" },
    cancelInApp: { v: "n/a", note: "Not stated on the pricing page" },
  },
  billingTerms: {
    refunds: "A 24-hour refund window is stated on the pricing page as of Oct 8, 2026.",
    cancel: "Cancellation steps are not described on the pricing page.",
    sourceUrl: PRICING,
    checkedAt: CHECKED,
  },
  quotes: [
    {
      text: "I paid for the business plan and can't upload more than 10 videos.",
      date: "2026-02-04",
      url: "https://www.trustpilot.com/review/sendshort.ai",
      evidences: "metering",
    },
  ],
  verification: {
    method: "fetch",
    date: CHECKED,
    note: "Pricing page fetched directly on Oct 8, 2026; the same figures appear on sendshort.ai/compare/opus-clip-vs-sendshort/. Annual figures are the per-month amounts the page shows ($15, $23, $47); annual totals are not printed, so none are recorded. SendShort's own compare pages are inconsistent on the entry price: $15 per month on most of them and $20 per month on the Pictory and InVideo pages. Upload length limits are not published anywhere official.",
  },
  seoPattern:
    "sendshort.ai/compare/<competitor>-vs-sendshort/ (22 pages, localized copies) plus /guides/<competitor>-alternatives/; no page about Crayo",
};
